import { useState } from 'react';
import { Loader2, User, Mail, Phone, MessageSquareText } from 'lucide-react';

const field = 'w-full border border-gray-200 rounded-lg pl-9 pr-3 py-2.5 text-sm bg-white focus:outline-none focus:border-green-600';
const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

const Input = ({ icon: Icon, ...p }) => (
  <div className="relative">
    <Icon size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
    <input className={field} {...p} />
  </div>
);

export const PreChatForm = ({ onStart }) => {
  const [f, setF] = useState({ name: '', email: '', phone: '', text: '' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name.trim() || !EMAIL.test(f.email.trim()) || f.phone.replace(/\D/g, '').length < 7) {
      setErr('Please enter your name, a valid email and contact number.');
      return;
    }
    setBusy(true); setErr('');
    try { await onStart({ ...f, text: f.text.trim() || 'Hi, I would like to chat about a drafting project.' }); } catch (ex) { setErr(ex.message); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="bg-white border border-gray-200 rounded-xl p-4 space-y-2.5 shadow-sm ld-chat-in" data-testid="prechat-form">
      <p className="text-sm font-semibold text-gray-800">Start a chat — we reply in seconds</p>
      <p className="text-xs text-gray-500 -mt-1">Your details let our specialist follow up if you step away.</p>
      <Input icon={User} placeholder="Your name *" value={f.name} onChange={set('name')} autoComplete="name" data-testid="prechat-name" />
      <Input icon={Mail} type="email" placeholder="Email ID *" value={f.email} onChange={set('email')} autoComplete="email" data-testid="prechat-email" />
      <Input icon={Phone} type="tel" placeholder="Contact number *" value={f.phone} onChange={set('phone')} autoComplete="tel" data-testid="prechat-phone" />
      <div className="relative">
        <MessageSquareText size={15} className="absolute left-3 top-3 text-gray-400" />
        <textarea rows={2} className={`${field} resize-none`} placeholder="How can we help? (optional)" value={f.text} onChange={set('text')} data-testid="prechat-message" />
      </div>
      {err && <p className="text-xs text-red-600" data-testid="prechat-error">{err}</p>}
      <button disabled={busy} className="w-full bg-green-600 hover:bg-green-700 text-white text-sm font-semibold py-2.5 rounded-lg transition-colors disabled:opacity-60 flex items-center justify-center gap-2" data-testid="prechat-start-btn">
        {busy && <Loader2 size={15} className="animate-spin" />} Start chat
      </button>
    </form>
  );
};
